<template>
    <div :class="$style.icons">
        <CloudpaymentsLogo />
    </div>
</template>

<script>
import CloudpaymentsLogo from "../shapes/CloudpaymentsLogo";

export default {
    name: "CloudPaymentsBlockIcons",
    components: {
        CloudpaymentsLogo
    },
};
</script>

<style lang="postcss" module>
.icons {
    display: flex;
    margin-top: 0;
    align-items: center;
}

.icons > svg:first-child {
    height: 55px;
    width: 65px;
}

.icons > svg:not(:first-child) {
    height: 18px;
    width: auto;
}

.icons > svg:not(:last-child) {
    margin-right: 12px;
}
</style>
